module.exports = __webpack_public_path__ + "img/rice_description.b4271937.svg";